import './statusDivider.scss';

export const statusDividerTemplate = (model) => {
	const { status, color, hideDividers } = model;
	const dividerLineCss = color ? `border:0.1px solid ${color};` : '';
	const dividerTextCss = color ? `color: ${color}; ` : '';
	const dividerClass = hideDividers ? 'engt-hidden' : '';

	/* html */
	const html = `
        <div class="engt-status-divider">
            <hr class="${dividerClass}" style="${dividerLineCss}"/>
        </div>
        <span class="engt-divider-text" style="${dividerTextCss}">${status}</span>
        <div class="engt-status-divider">
            <hr class="${dividerClass}" style="${dividerLineCss}" />
        </div>
    `;

	return html;
};
